<ng-container *transloco="let _t">

<div class="row h-100" *ngIf="objectif!=undefined">

<div class="objcolumn col-3">
	<h2><auto-editable 
		[value]="objectif.name" 
		(changeValue)="objectif.name=$event" 
		type="text"
		[placeholder]="_t('rm-objectif-placeholder-0')"></auto-editable>
	</h2>

	<h4>{{ _t('rm-objectif-h4-0') }}</h4>
	<p><auto-editable class="fullwidth"
		[value]="objectif.redaction" 
		(changeValue)="objectif.redaction=$event" 
		type="textarea"
		[placeholder]="_t('rm-objectif-placeholder-1')"></auto-editable>
	</p>

	<h4 class="float">{{ _t('rm-objectif-h4-1') }}</h4>
	<div class="datePickerFormField">
		<mat-date-range-input [rangePicker]="picker">
			<input matStartDate [(ngModel)]="objectif.start" />
			<input matEndDate [(ngModel)]="objectif.end" />
		</mat-date-range-input>
		
		<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
		<mat-date-range-picker #picker></mat-date-range-picker>
	</div>
	

	<div class="budget">
		<h4 class="float">{{ _t('rm-objectif-h4-2') }} </h4>
		<auto-editable 
			[value]="objectif.budget" 
			(changeValue)="objectif.budget=$event" 
			type="text"
			[placeholder]="_t('rm-objectif-placeholder-2')"></auto-editable> 
		€
	</div>
	<h4>{{ _t('rm-objectif-h4-3') }}</h4>
	<rm-team [id]="objectifTeamList"
		[connectedLists]="actionTeamsList"
		[users]="objectif.users"
		[deleteOnDragOut]="false"
		[showAddButton]="true"
	></rm-team>
	
  <p>&nbsp;</p>
  <h4>{{ _t('rm-objectif-h4-4') }}</h4>
  <rm-objectif-doughnut #doughnut class="small"
  	[values]="chartValues"
	[showTitle]="false"
	[showLegend]="true"
	[animation]="true">
  </rm-objectif-doughnut>

</div>

<div class="actioncolumn col-9" *ngIf="mod=='list'">
	<table>
		<thead class="darkbg"><tr>
			<th class="col-1">{{ _t('rm-objectif-th-1') }}</th>
			<th class="td-action col-2">{{ _t('rm-objectif-th-2') }}</th>
			<th class="td-acteurs col-2">{{ _t('rm-objectif-th-3') }}</th>
			<th class="td-infos col-3">{{ _t('rm-objectif-th-4') }}</th>
			<th class="td-date col-3">{{ _t('rm-objectif-th-5') }}</th>
			<th class="td-budget col-1">{{ _t('rm-objectif-th-6') }}</th>
		</tr></thead>
		<tbody>
			<tr *ngFor="let action of objectif.actions; let i=index"
			  [ngClass]="{
				'statusCanceled': action.status==-2,
				'statusNew': action.status==-1,
				'statusTODO':action.status==0,
				'statusWIP':action.status==1,
				'statusFINN':action.status==2
			  }" 
			  (click)="openAction(action)">
				<!--Suppr-->
				<td> 
					<button *ngIf="action.status>=0"
						mat-mini-fab color="secondary"
						(click)="action.status=-2; sortActions()" >
						<mat-icon [title]="_t('rm-objectif-title-0')">delete</mat-icon>
					</button>
					<button *ngIf="action.status==-2"
						mat-mini-fab color="warn"
						(click)="deleteAction(action, i)" >
						<mat-icon [title]="_t('rm-objectif-title-1')">delete_forever</mat-icon>
					</button>
					<button *ngIf="action.status==-2"
						mat-mini-fab color="basic"
						(click)="action.status=0; sortActions()" >
						<mat-icon [title]="_t('rm-objectif-title-2')">restore_from_trash</mat-icon>
					</button>
				</td>
				<!-- Action name -->
				<td class="td-action">
					{{action.name}}
				</td>
				<!--Actors-->
				<td class="td-acteurs">
					<rm-team [id]="'actionTeam'+action.id"
						[connectedLists]="[objectifTeamList]"
						[users]="action.users"
						[deleteOnDragOut]="true"
						(changeValue)="action.users=$event"
					></rm-team>
				</td>
				<!--Infos-->
				<td class="td-infos">
					<span *ngIf="action.jsonDetails.todo"
						[title]="action.todoFraction+' tâches complétées'">
						&nbsp;
						<mat-icon>playlist_add_check</mat-icon>
						{{action.todoFraction}}
						&nbsp;
					</span>
					<span *ngIf="action.jsonDetails.comments"
						[title]="action.commentsCount+' notes'">
						&nbsp;
						<mat-icon>comment</mat-icon>
						{{action.commentsCount}}
						&nbsp;
					</span>
				</td>
				<!--Dates-->
				<td class="td-date">
					{{action.startDate | date:'shortDate':undefined:'fr-FR'}} 
				    - 
					{{action.endDate | date:'shortDate':undefined:'fr-FR'}}
				</td>
				<!--Budget-->
				<td class="td-budget">
					{{action.actionBudget}}
				</td>
			</tr>
			
			<tr class="totalrow">
				<td></td>
				<td >{{ _t('rm-objectif-total-reel') }}</td>
				<td></td>
				<td></td>
				<td>
				  {{firstActionDate | date:'shortDate':undefined:'fr-FR'}}
				-
				  {{lastActionDate | date:'shortDate':undefined:'fr-FR'}}
				</td>
				<td>{{totalActionBudget}}</td>
			</tr>

			<tr class="previsrow">
				<td></td>
				<td >{{ _t('rm-objectif-total-previs') }}</td>
				<td></td>
				<td></td>
				<td>
				  {{objectif.start | date:'shortDate':undefined:'fr-FR'}}
				-
				  {{objectif.end | date:'shortDate':undefined:'fr-FR'}}
				</td>
				<td>{{objectif.budget}}</td>
			</tr>
		</tbody>
	</table>

	<rm-action id="openedAction"
		*ngIf="openedAction!=null"
		[action]="openedAction"
		[objectifId]="objectif.id"
		[connectedUserList]="[objectifTeamList]"
		[fold]="false"
		[singleView]="true"
		(addTriggered)="addAction($event)"
		(changeStatusTriggered)="sortActions()"
		(closeTriggered)="openedAction=null">
	</rm-action>
</div>

<div class="actioncolumn col-9 row" *ngIf="mod=='kanban'">
	<div class="col-4" cdkDropList
		#todoList="cdkDropList"
		id="todoList"
		[cdkDropListData]="todoActions"
		[cdkDropListConnectedTo]="[wipList,finnishedList]"
		(cdkDropListDropped)="drop($event)">
		<h4>{{ _t('rm-objectif-h4-5') }}</h4>
		<rm-action *ngFor="let action of todoActions; let i=index;"
			#kanbanAction
			[id]="'todo-'+i"
			[action]="action"
			[objectifId]="objectif.id"
			[connectedUserList]="[objectifTeamList]"
			[fold]="true"
			[singleView]="false"
			(changeStatusTriggered)="sortActions()"
			cdkDrag
			>
		</rm-action>
	</div>
	<div class="col-4" cdkDropList
		#wipList="cdkDropList"
		[id]="'wipList'"
		[cdkDropListData]="wipActions"
		[cdkDropListConnectedTo]="[todoList,finnishedList]"
		(cdkDropListDropped)="drop($event)">
		<h4>{{ _t('rm-objectif-h4-6') }}</h4>
		<rm-action *ngFor="let action of wipActions; let i=index;"
			#kanbanAction
			[id]="'wip-'+i"
			[action]="action"
			[objectifId]="objectif.id"
			[connectedUserList]="[objectifTeamList]"
			[fold]="true"
			[singleView]="false"
			(changeStatusTriggered)="sortActions()"
			cdkDrag>
		</rm-action>
	</div>
	<div class="col-4" cdkDropList
		#finnishedList="cdkDropList"
		[id]="'finnishedList'"
		[cdkDropListData]="finnishedActions"
		[cdkDropListConnectedTo]="[wipList,todoList]"
		(cdkDropListDropped)="drop($event)">
		<h4>{{ _t('rm-objectif-h4-7') }}</h4>
		<rm-action *ngFor="let action of finnishedActions; let i=index;"
			#kanbanAction
			[id]="'finnished-'+i"
			[action]="action"
			[objectifId]="objectif.id"
			[connectedUserList]="[objectifTeamList]"
			[fold]="true"
			[singleView]="false"
			(changeStatusTriggered)="sortActions()"
			cdkDrag>
		</rm-action>
	</div>
</div>

	<div class="actioncolumn col-9" *ngIf="inIndicAvailable && mod=='indic'">
	<rm-indicator
	[indicator]="objectif.answer.indicator"
	[diagnostic]="objectif.answer.diagnostic"
	[objectif]="objectif"
	[embedded]="true"></rm-indicator>
	</div>
</div>

</ng-container>